var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCalendarCheckImg = function SvgCalendarCheckImg(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#calendar_check_img_svg__a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#212123",
    d: "M8.625 5.25h6.75V3.56a.56.56 0 1 1 1.12 0v1.69h1.12c1.24 0 2.25 1.01 2.25 2.25v11.25c0 1.24-1.01 2.25-2.25 2.25H6.375c-1.24 0-2.25-1.01-2.25-2.25V7.5c0-1.24 1.01-2.25 2.25-2.25h1.12V3.56a.56.56 0 1 1 1.12 0v1.69zM5.245 7.5v1.12h13.5V7.5c0-.62-.5-1.12-1.12-1.12H6.375c-.62 0-1.12.5-1.12 1.12zm0 11.25c0 .62.5 1.12 1.12 1.12h11.25c.62 0 1.12-.5 1.12-1.12v-9H5.245zm6.59-1.85c-.22.22-.58.22-.79 0l-2.25-2.25a.555.555 0 0 1 0-.79c.22-.22.58-.22.79 0l1.85 1.85 3.54-3.54c.22-.22.58-.22.79 0 .22.22.22.58 0 .79l-3.94 3.94z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#E3E7EC",
    d: "M5.245 7.5v1.12h13.5V7.5c0-.62-.5-1.12-1.12-1.12H6.375c-.62 0-1.12.5-1.12 1.12z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "calendar_check_img_svg__a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M4.125 3h15.75v18H4.125z"
  })))));
};
export default SvgCalendarCheckImg;